
const OrdersByToyUserUuid_query = `query($userUuid: String!){
  ordersByToyUseruuid(userUuid: $userUuid){
    toyId{
        toyImages{
          fileName
        }
        title
        ratingNo
        ratingComment
      }
    
      userId{
        username
        userUuid
      }    
    
    orderDate
  }
     
}`;

module.exports = {
  ORDERS_BY_TOY_USER_UUID: OrdersByToyUserUuid_query,
 
}